var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import * as StaticPageFactory from '../../../classes/definitions/brand/staticPage';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import staticPageSchema from "../../../schemas/staticPageSchema";
import Input from '../../UI/Input/Input';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import Email from '../../UI/Builder/Builder'; // Adjust the import path for Email component
var StaticPageForm = /** @class */ (function (_super) {
    __extends(StaticPageForm, _super);
    function StaticPageForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.brandId = '';
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(staticPageSchema),
            formIsValid: false,
            categoryId: 0,
            brandId: 0,
            categoriesSuggestions: [],
            currentCategory: null,
            brandCategory: null,
            showModal: false,
            currentId: '',
            currentModalContent: {
                designHtml: '',
                designJson: null,
            }
        };
        _this.getStaticPage = function (brandId, staticPageId) {
            _this.api.getStaticPage(brandId, staticPageId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                console.log(error);
                //    const defaultMessage: string = 'Грешка при зареждане на статичната страница';
                //    this.http.handleError(error, this.messages, defaultMessage, this.props.history);
            });
        };
        _this.setupFieldsOptions = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _this.setDisplayOptions(updatedFormConfig, _.get(data, 'data.displays'));
            _this.setState({ formConfig: updatedFormConfig }, function () {
                // After setting up the async options
                if (_this.editId !== '-1') {
                    _this.getStaticPage(_this.brandId, _this.editId);
                }
            });
        };
        _this.setDisplayOptions = function (updatedFormConfig, rawStatuses) {
            for (var key in rawStatuses) {
                if (Object.prototype.hasOwnProperty.call(rawStatuses, key)) {
                    updatedFormConfig.display.elementConfig.options.push(new DropdownOption({
                        label: key,
                        value: key,
                    }));
                }
            }
        };
        _this.setDataToForm = function (data) {
            var staticPage = StaticPageFactory.createStaticPage(_.get(data, 'attributes', {}));
            var api = new ApiRequests();
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', staticPage.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', staticPage.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'slug.value', staticPage.Slug);
            _.set(updatedFormConfig, 'slug.touched', true);
            _.set(updatedFormConfig, 'slug.valid', true);
            _.set(updatedFormConfig, 'position.value', staticPage.Position);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'bg_description.value', staticPage.BgDescription);
            _.set(updatedFormConfig, 'bg_description.touched', true);
            _.set(updatedFormConfig, 'bg_description.valid', true);
            _.set(updatedFormConfig, 'bg_bottom_description.value', staticPage.BgBottomDescription);
            _.set(updatedFormConfig, 'bg_bottom_description.touched', true);
            _.set(updatedFormConfig, 'bg_bottom_description.valid', true);
            _.set(updatedFormConfig, 'en_description.value', staticPage.EnDescription);
            _.set(updatedFormConfig, 'en_description.touched', true);
            _.set(updatedFormConfig, 'en_description.valid', true);
            _.set(updatedFormConfig, 'en_bottom_description.value', staticPage.EnBottomDescription);
            _.set(updatedFormConfig, 'en_bottom_description.touched', true);
            _.set(updatedFormConfig, 'en_bottom_description.valid', true);
            _.set(updatedFormConfig, 'display.value', staticPage.Display);
            _.set(updatedFormConfig, 'display.touched', true);
            _.set(updatedFormConfig, 'display.valid', true);
            _.set(updatedFormConfig, 'canonical_url.value', staticPage.CanonicalUrl);
            _.set(updatedFormConfig, 'canonical_url.touched', true);
            _.set(updatedFormConfig, 'canonical_url.valid', true);
            _.set(updatedFormConfig, 'meta_title.value', staticPage.MetaTitle);
            _.set(updatedFormConfig, 'meta_title.touched', true);
            _.set(updatedFormConfig, 'meta_title.valid', true);
            _.set(updatedFormConfig, 'meta_description.value', staticPage.MetaDescription);
            _.set(updatedFormConfig, 'meta_description.touched', true);
            _.set(updatedFormConfig, 'meta_description.valid', true);
            var attributes = _.get(data, 'attributes', {}); // Changed from obj to attributes
            attributes.category ? _this.setState({
                currentCategory: {
                    id: Number(attributes.category.id),
                    slug: attributes.category.attributes.bg_name + " (" + attributes.category.attributes.slug + ")"
                }
            }) : _this.setState({
                currentCategory: null
            });
            attributes.brand_category ? _this.setState({
                brandCategory: Number(attributes.brand_category.id)
            }) : _this.setState({
                brandCategory: null
            });
            _.set(updatedFormConfig, 'categories.value', attributes.category ? attributes.category.attributes.bg_name + " (" + attributes.category.attributes.slug + ")" : null);
            _.set(updatedFormConfig, 'categories.touched', true);
            _.set(updatedFormConfig, 'categories.valid', true);
            _.set(updatedFormConfig, 'brand_category.value', attributes.brand_category ? "" + attributes.brand_category.attributes.bg_name : null);
            _.set(updatedFormConfig, 'brand_category.touched', true);
            _.set(updatedFormConfig, 'brand_category.valid', true);
            // Function to add value from corresponding element
            var addValueFromCorrespondingElement = function (obj) {
                for (var key in obj) {
                    if (obj[key].elementType === "buttonModal") {
                        var correspondingKey = key.replace("_json", "");
                        if (obj[correspondingKey]) {
                            obj[key].value = obj[correspondingKey].value;
                            obj[key].valueJson = {
                                body: {
                                    id: "" + correspondingKey,
                                    rows: [
                                        {
                                            id: "" + correspondingKey,
                                            cells: [
                                                {
                                                    contents: []
                                                }
                                            ],
                                            columns: [
                                                {
                                                    id: "LW0qh6mDEB",
                                                    contents: [
                                                        {
                                                            id: "9I7WSiTa5e",
                                                            type: "html",
                                                            values: {
                                                                html: "" + obj[correspondingKey].value,
                                                                displayCondition: null,
                                                                containerPadding: "10px",
                                                                anchor: "",
                                                                _meta: {
                                                                    htmlID: "u_content_html_1",
                                                                    htmlClassNames: "u_content_html"
                                                                },
                                                                selectable: true,
                                                                draggable: true,
                                                                duplicatable: true,
                                                                deletable: true,
                                                                hideable: true
                                                            }
                                                        }
                                                    ],
                                                }
                                            ],
                                        }
                                    ],
                                },
                            };
                        }
                    }
                }
            };
            if (staticPage.BgDescriptionJson === null) {
                addValueFromCorrespondingElement(updatedFormConfig);
            }
            else {
                _.set(updatedFormConfig, 'bg_description_json.valueJson', staticPage.BgDescriptionJson);
                _.set(updatedFormConfig, 'bg_description_json.touched', true);
                _.set(updatedFormConfig, 'bg_description_json.valid', true);
                _.set(updatedFormConfig, 'bg_description_json.value', staticPage.BgDescription);
            }
            if (staticPage.EnDescriptionJson === null) {
                addValueFromCorrespondingElement(updatedFormConfig);
            }
            else {
                _.set(updatedFormConfig, 'en_description_json.valueJson', staticPage.EnDescriptionJson);
                _.set(updatedFormConfig, 'en_description_json.touched', true);
                _.set(updatedFormConfig, 'en_description_json.valid', true);
                _.set(updatedFormConfig, 'en_description_json.value', staticPage.EnDescription);
            }
            if (staticPage.BgBottomDescriptionJson === null) {
                addValueFromCorrespondingElement(updatedFormConfig);
            }
            else {
                _.set(updatedFormConfig, 'bg_bottom_description_json.valueJson', staticPage.BgBottomDescriptionJson);
                _.set(updatedFormConfig, 'bg_bottom_description_json.touched', true);
                _.set(updatedFormConfig, 'bg_bottom_description_json.valid', true);
                _.set(updatedFormConfig, 'bg_bottom_description_json.value', staticPage.BgBottomDescription);
            }
            if (staticPage.EnBottomDescriptionJson === null) {
                addValueFromCorrespondingElement(updatedFormConfig);
            }
            else {
                _.set(updatedFormConfig, 'en_bottom_description_json.valueJson', staticPage.EnBottomDescriptionJson);
                _.set(updatedFormConfig, 'en_bottom_description_json.touched', true);
                _.set(updatedFormConfig, 'en_bottom_description_json.valid', true);
                _.set(updatedFormConfig, 'en_bottom_description_json.value', staticPage.EnBottomDescription);
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig)
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) }, function () {
                if (_this.state.formConfig.categories) {
                    if (_this.state.formConfig.categories.value) {
                        if (_this.state.formConfig.categories.value !== "" && typeof _this.state.formConfig.categories.value.value !== 'undefined') {
                            _this.setState({
                                categoryId: Number(_this.state.formConfig.categories.value.value),
                                currentCategory: null,
                            });
                        }
                    }
                    else {
                        _this.setState({ categoryId: null, currentCategory: null });
                    }
                }
                if (_this.state.formConfig.brand_category) {
                    if (_this.state.formConfig.brand_category.value) {
                        if (_this.state.formConfig.brand_category.value !== "" && typeof _this.state.formConfig.brand_category.value.value !== 'undefined') {
                            _this.setState({
                                brandId: Number(_this.state.formConfig.brand_category.value.value),
                                brandCategory: null
                            });
                        }
                    }
                    else {
                        _this.setState({ brandId: null,
                            brandCategory: null });
                    }
                }
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedStaticPage = StaticPageFactory.createStaticPage({
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
                slug: _.get(formData, 'slug.value', ''),
                position: _.get(formData, 'position.value', ''),
                bg_description: _.get(formData, 'bg_description_json.value', ''),
                bg_description_json: JSON.stringify(_.get(formData, 'bg_description_json.valueJson', '')),
                en_description: _.get(formData, 'en_description_json.value', ''),
                en_description_json: JSON.stringify(_.get(formData, 'en_description_json.valueJson', '')),
                bg_bottom_description: _.get(formData, 'bg_bottom_description_json.value', ''),
                bg_bottom_description_json: JSON.stringify(_.get(formData, 'bg_bottom_description_json.valueJson', '')),
                en_bottom_description: _.get(formData, 'en_bottom_description_json.value', ''),
                en_bottom_description_json: JSON.stringify(_.get(formData, 'en_bottom_description_json.valueJson', '')),
                category_id: _this.state.currentCategory ? _this.state.currentCategory.id : _this.state.categoryId,
                brand_category_id: _this.state.brandCategory ? _this.state.brandCategory : _this.state.brandId,
                display: _.get(formData, 'display.value', ''),
                canonical_url: _.get(formData, 'canonical_url.value', ''),
                meta_title: _.get(formData, 'meta_title.value', ''),
                meta_description: _.get(formData, 'meta_description.value', ''),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createStaticPage : _this.api.updateStaticPage;
            actionMethod(submittedStaticPage, _this.brandId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toStaticPagesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на статична страница';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            var searchMethod = type === 'brand_category' ? _this.api.searchBrandCategory : _this.api.searchCategories;
            searchMethod(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: type === 'brand'
                            ? _.get(item, 'attributes.name', '')
                            : _.get(item, 'attributes.bg_name', '') + " (" + _.get(item, 'attributes.slug', '') + ")",
                        value: _.get(item, 'id'),
                    });
                }
                var obj = {};
                obj['categoriesSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        // Method to open the modal
        _this.openModal = function (formElementId) {
            var formElement = _this.state.formConfig[formElementId];
            _this.setState({
                showModal: true,
                currentId: formElementId,
                currentModalContent: {
                    designHtml: formElement.value || null,
                    designJson: formElement.valueJson || null,
                },
            });
        };
        // Method to close the modal
        _this.closeModal = function () {
            _this.setState({
                showModal: false,
                currentModalContent: {
                    designHtml: '',
                    designJson: null,
                },
            });
        };
        _this.showInfoModal = function () {
            _this.setState({
                showModal: false,
                currentModalContent: {
                    designHtml: _this.state.currentModalContent.designHtml,
                    designJson: _this.state.currentModalContent.designJson,
                },
            });
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[_this.state.currentId]);
            updatedFormElement.value = _this.state.currentModalContent.designHtml.replace(/\n/g, '');
            updatedFormElement.valueJson = _this.state.currentModalContent.designJson;
            var prevId = _this.state.currentId.replace("_json", "");
            updatedFormConfig[_this.state.currentId] = updatedFormElement;
            if (updatedFormConfig[prevId]) {
                updatedFormConfig[prevId].value = _this.state.currentModalContent.designHtml.replace(/\n/g, '');
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.toStaticPagesPage = function () {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId + AppRoutes.staticPages.path);
        };
        // Method to handle design export from Email component
        _this.handleDesignExport = function (html, json) {
            _this.setState(function (prevState) { return ({
                currentModalContent: {
                    designHtml: html || '',
                    designJson: json
                },
            }); });
        };
        return _this;
    }
    StaticPageForm.prototype.componentDidMount = function () {
        var _this = this;
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
        this.editId = _.get(this.props, 'match.params.staticPageId', '-1');
        var api = new ApiRequests();
        api.getDisplayOptions(this.brandId).then(function (data) { return _this.setupFieldsOptions(data); });
        // load edit value
        if (this.editId !== '-1' && this.brandId !== '-1') {
            this.props.isEdit(true);
            this.getStaticPage(this.brandId, this.editId);
        }
    };
    StaticPageForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, showModal = _a.showModal, currentModalContent = _a.currentModalContent, formConfig = _a.formConfig, formIsValid = _a.formIsValid, categoriesSuggestions = _a.categoriesSuggestions;
        var formElementsArray = [];
        var modalInfo;
        if (formConfig.hasOwnProperty(this.state.currentId)) {
            modalInfo = {
                config: formConfig[this.state.currentId],
                id: this.state.currentId
            };
        }
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType); }, suggestions: categoriesSuggestions, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); }, modalButtonAction: function (event) { return _this.openModal(formElement.id); }, buttonModalText: "Промяна на съдържанието", modalhtmlContent: formElement.config.value && Object.keys(formElement.config.value).length > 0 ? formElement.config.value : null, modalButton: formElement.config.elementType === 'buttonModal' ? true : false }));
        }));
        // Modal content
        var modalContent = showModal && currentModalContent ? (React.createElement(Dialog, { visible: showModal, onHide: this.closeModal, header: "\u041F\u0440\u043E\u043C\u044F\u043D\u0430 \u043D\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435\u0442\u043E" },
            React.createElement("div", null,
                React.createElement(Email, { onDesignExport: this.handleDesignExport, designHtml: modalInfo.config.value, designJson: modalInfo.config.valueJson })),
            React.createElement("div", { className: "p-d-flex p-jc-end" },
                React.createElement(Button, { label: "Close", onClick: this.closeModal }),
                React.createElement(Button, { label: "Save", onClick: this.showInfoModal })))) : null;
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toStaticPagesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            modalContent,
            actionBtns));
    };
    return StaticPageForm;
}(React.Component));
// @ts-ignore
export default withRouter(StaticPageForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/StaticPages/StaticPageForm/StaticPageForm.tsx
// module id = 541
// module chunks = 0